import React from 'react'
export default function BoldAddIcon({ size = 24, width = size, height = size, fill, secondaryFill, stroke, secondaryStroke, children }) {
  return (<svg width={width} height={height} xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24">{children}
<g fill={fill} stroke={stroke} className="nc-icon-wrapper"><path d="M23 9h-8V1c0-.6-.4-1-1-1h-4c-.6 0-1 .4-1 1v8H1c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1h8v8c0 .6.4 1 1 1h4c.6 0 1-.4 1-1v-8h8c.6 0 1-.4 1-1v-4c0-.6-.4-1-1-1z"/></g></svg>)
}
